import { ThemeConfig } from 'antd';
import colors from './colors';

const theme: ThemeConfig = {
  token: {
    colorPrimary: colors.primary,
    colorPrimaryBg: colors.transparent,
    colorPrimaryHover: colors.primaryHover,
    colorPrimaryActive: colors.primaryActive,
    fontFamily: 'Nunito, sans-serif',
  },
  components: {
    Button: {
      defaultColor: colors.white,
      defaultBg: colors.secondary,
      defaultActiveColor: colors.primaryActive,
      defaultHoverBg: colors.primaryHover,
      defaultHoverColor: colors.white,
    },
    Typography: {
      titleMarginBottom: 0,
    },
    Table: {
      headerBg: colors.white,
    },
    Tabs: {
      itemActiveColor: 'orange',
      colorPrimary: 'orange',
      itemColor: 'gray',
    },
  },
};

export default theme;
